import { jsx as r } from "react/jsx-runtime";
const e = () => /* @__PURE__ */ r(
  "path",
  {
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 3 16.5 3 16.5M3 16.5H6.5M3 16.5V20M2 12C2 6.47715 6.44444 2 12 2C18.6667 2 22 7.5 22 7.5M22 7.5V4M22 7.5H18.5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
);
export {
  e as default
};
